module.exports = __webpack_public_path__ + "static/media/animation-screen.9ac461bd.svg";